import { Button } from '@ontruck/orc';
import { useFieldArray, useController, useFormContext } from 'react-hook-form';
import { UncontrolledInput } from 'components/Form';

import { defaultDetail } from './VenueDetail';

const VenueNameEditMode = ({ name, error, fieldName, isCreating }) => {
  const { register } = useFormContext();

  const { field } = useController({
    name: fieldName,
    defaultValue: name,
    shouldUnregister: false,
    rules: {
      required: 'Venue or Company name is required',
    },
  });

  const alternativesNamesFieldName = `${fieldName}Alternatives`;

  const { fields, append } = useFieldArray({
    name: alternativesNamesFieldName,
    shouldUnregister: false,
  });

  return (
    <>
      <div className="field-container">
        <UncontrolledInput
          className="input"
          placeholder="Venue or Company name"
          hasError={!!error?.message}
          {...field}
        />
        {!!error?.message && <div className="field-error">{error?.message}</div>}
      </div>
      {isCreating && (
        <>
          <div className="field-container">
            <div>
              {fields.map((alternativeNameField, index) => (
                <UncontrolledInput
                  key={alternativeNameField.id}
                  className="input"
                  placeholder="Alternative name"
                  {...register(`${alternativesNamesFieldName}.${index}`)}
                />
              ))}
            </div>
          </div>
          <div>
            <Button
              text="Add alternative name"
              nude
              icon="plus"
              iconPosition="left"
              onClick={() => append()}
            />
          </div>
        </>
      )}
    </>
  );
};

const VenueNameRenderer = ({ value: name, isEditing, isCreating, fieldName, error }) => {
  if (isEditing) {
    return (
      <VenueNameEditMode name={name} fieldName={fieldName} error={error} isCreating={isCreating} />
    );
  }

  if (!name) {
    return <>{defaultDetail}</>;
  }

  return <>{name}</>;
};

export default VenueNameRenderer;
